// Utils
// Constants
import { DIRECTION, FLIGHTS_CABIN_CLASS, LOG_TYPE } from '../const/app';
import SupplierCodes from './SupplierCodes';
import { find, propEq, isNil, isNilOrEmpty } from './general';
import { errorLogger } from './errors';
// Actions
// Models
import TravelBookingItemModel from '../models/TravelBookingItemModel';
// Interfaces

export const applyExtAction = (callback:Function, param: any) => (callback) ? callback(param) : null;

export const getSupplierNameByCode = (code:string) => {
  const supplier = find(propEq('ident', code))(SupplierCodes);

  if (isNilOrEmpty(supplier)) {
    // Use the code as is
    return code;
  }
  return supplier.name;
};

export const getFlightCabinClassByKey = (key:string) => {
  if (isNilOrEmpty(key)) {
    errorLogger('Flight cabin class cannot be null or empty', LOG_TYPE.ERROR);
    return FLIGHTS_CABIN_CLASS.ECONOMY;
  }

  switch (key[0].toUpperCase()) {
    case 'E':
      return FLIGHTS_CABIN_CLASS.ECONOMY;
    case 'P':
      return FLIGHTS_CABIN_CLASS.PREMIUM_ECONOMY;
    case 'B':
      return FLIGHTS_CABIN_CLASS.BUSINESS;
    case 'F':
      return FLIGHTS_CABIN_CLASS.FIRST;
    default:
      return FLIGHTS_CABIN_CLASS.ECONOMY;
  }
};

export const getOppositeDirection = (direction: DIRECTION) =>
  direction === DIRECTION.OUTWARD ? DIRECTION.INBOUND : DIRECTION.OUTWARD;

// One booking item can hold both fares of a round trip, and only the fare named by `fare_id`
// travels in the item's own `direction`. Any other fare of the same item is the return of it.
export const getFareDirection = (
  fareId: number,
  travelBookingItem: TravelBookingItemModel,
): DIRECTION => {
  const fareIds = (travelBookingItem?.fareIds ?? []).map(Number);

  if (isNil(travelBookingItem?.direction) || !fareIds.includes(Number(fareId))) {
    return undefined;
  }

  return Number(travelBookingItem.fareId) === Number(fareId)
    ? travelBookingItem.direction
    : getOppositeDirection(travelBookingItem.direction);
};
